import CookieBanner from '@jobseeker/feature-navigation/widgets/CookieBanner';
import {CookieBannerWidget} from '@jobseeker/feature-navigation/components/CookieBanner/types';

const CookieBannerHarness = (props: CookieBannerWidget) => {
  return <CookieBanner {...props} />;
};

export default CookieBannerHarness;
